import { always } from "../../../base/utils/ramdaEquivalents.utils";
import { makeObservableRouteDef } from "../../../base/utils/routes.utils";
import ModuleCounselling from "./Counselling.module";

export const CounsellingModuleRouteDef = makeObservableRouteDef({
  identifier: 'counselling',
  urlFactory: always('counselling'),
  composeTitle: always('Counselling'),
  component: ModuleCounselling,
})